<template>
    <el-dialog
        title="预签收"
        width="85vw"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :before-close="beforeClose"
        :custom-class="'performanceSignInDialog'"
        top="5vh"
    >
        <div class="signRight">
            <sign-in-form
                ref="signInForm"
                :rowData="rowData"
                :goodsList="goodsList"
                :viewStatus="viewStatus"
            ></sign-in-form>

            <preReceipt-table
                ref="preReceiptTable"
                :rowData="rowData"
                :tableDataList="tableDataList"
                @setCount="getCount"
            ></preReceipt-table>
        </div>
        <template #footer>
                <el-button @click="beforeClose">取消</el-button>
                <el-button
                    type="primary"
                    :loading="btnLoading"
                    @click="handlePreReceipt"
                >预签收保存</el-button>
        </template>
    </el-dialog>
</template>
<script>
import SignInForm from './SignInForm.vue';
import preReceiptTable from './preReceiptTable.vue';
import { mapState } from 'vuex';
import {
    getReceiptSignDetailInfo,
    queryReceiptDetailByTaskNo,
    predictSign
} from '@/modules/transport/otp/api/performanceReceiptSign.js';
import { OPERATE_TYPE } from '../utils/constant.js';

export default {
    name: 'signInDialog',
    components: {
        SignInForm,
        preReceiptTable
    },
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            OPERATE_TYPE,
            viewStatus: '3', // table表头与B2CSignInTable一致，汇总计算逻辑同理，则固定传3
            btnLoading: false, // 按钮加载动画
            receiptInfo: {}, // 回单签收表单信息
            goodsList: [], // form组件参数
            tableDataList: [] // table组件参数
        };
    },
    computed: {
        ...mapState(['user'])
    },
    methods: {
        /**
         * @description 获取签收详情
         */
        getReceiptSignDetailInfo () {
            getReceiptSignDetailInfo({
                taskNo: this.rowData.taskNo // 运输单号
            }).then(res => {
                if (res && +res.code === 0) {
                    this.receiptInfo = Object.assign({}, { currentUserName: this.user.userName }, this.rowData, res.data);
                    this.$refs.signInForm.initFormData(this.receiptInfo);
                }
            }).finally(() => {
                this.getReceiptSignDetailList();
            });
        },

        /**
         * @description 获取签收详情列表
         */
        getReceiptSignDetailList () {
            queryReceiptDetailByTaskNo({ taskNo: this.rowData.taskNo }).then(res => {
                if (res && +res.code === 0) {
                    this.tableDataList = res.data.details || [];
                    this.goodsList = res.data.details || [];
                }
            });
        },

        handlePreReceipt () {
            this.$refs.preReceiptTable.validateDataIsTrue().then(tableData => {
                this.btnLoading = true;
                predictSign(tableData).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('预签收保存成功');
                        this.$emit('success', 'preReceiptDialogShow');
                    } else {
                        this.$message.warning(res.data.msg);
                    }
                }).finally(() => {
                    this.btnLoading = false;
                });
            }).catch(({ message }) => {
                this.$message.warning(message);
            });
        },

        /* 处理汇总变化 */
        getCount (data) {
            this.goodsList = data;
            this.$forceUpdate();
        },

        beforeClose () {
            this.$emit('update:preReceiptDialogShow', false);
        },
    },
    mounted () {
        this.getReceiptSignDetailInfo();
    }
};
</script>
<style lang="less">
@import url('./signIn.less');
</style>
